import { getAgentBySlug } from '@lib/api-services/agentsService'
import dynamic from 'next/dynamic'

const AppraisalForm = dynamic(() => import('@global/Form/AppraisalForm'), {
  ssr: false,
})

const AppraisalRequestPage = (props) => {
  const { office_agent_slug, take_me_to_field, referral_source, agent } = props

  return (
    <AppraisalForm
      office_agent_slug={office_agent_slug}
      referral_source={referral_source}
      take_me_to_field={take_me_to_field}
      agent={agent}
    />
  )
}

AppraisalRequestPage.getInitialProps = async (ctx, pageData) => {
  let office_agent_slug = ctx.query.slug
  let thankYouPagePath = ''
  let referral_source = ''

  let take_me_to_options = {
    type: 'select',
    value: 'Select from list',
    options: [
      {
        value: 'Select from list',
        label: 'Select from list',
      },
    ],
  }

  if (
    pageData &&
    pageData.take_me_to_links &&
    pageData.take_me_to_links.length > 0
  ) {
    pageData.take_me_to_links.map((link) => {
      take_me_to_options.options.push({
        value: link.link.path,
        label: link.link.title,
      })
    })
  }
  const take_me_to_field = {
    // This sets up other parts of the form field.
    // We only want to override the options.
    title: 'Thank you',
    copy: 'One of our property experts will call you for a confidential discussion.',
    fieldLabel: 'Take me to: ',
    field: {
      type: 'select',
      options: [
        {
          value: 'Select from list',
          label: 'Select from list',
        },
        {
          value: 'Home',
          label: '/',
        },
      ],
    },
    ...{ field: take_me_to_options },
  }

  const agent = await getAgentBySlug(office_agent_slug)

  return {
    pageData,
    take_me_to_field,
    thank_you_page_path: thankYouPagePath,
    referral_source: referral_source,
    office_agent_slug: office_agent_slug,
    agent: agent,
    wagtailPageType: 'AppraisalRequestPage',
  }
}
export default AppraisalRequestPage
